// Libs
import { Consequence} from '../../libs/utils';

export const SHOW_COLORED_NOT = 'SHOW_COLORED_NOT'
export const SHOW_FULL_WIDTH_NOT = 'SHOW_FULL_WIDTH_NOT'
export const SHOW_IMAGE_NOT = 'SHOW_IMAGE_NOT'
export const SHOW_BASIC_NOT = 'SHOW_BASIC_NOT'
export const ARM_PROMPT = 'ARM_PROMPT'
export const SHOW_PROMPT = 'SHOW_PROMPT'
export const SHOW_TOPBAR_NOT = 'SHOW_TOPBAR_NOT'
export const DECREASE_SHOW_FULL_WIDTH_NOT = 'DECREASE_SHOW_FULL_WIDTH_NOT'
export const SAT_ALERT = 'SAT_ALERT'

export function promptUser({ message, title, onCancel, onOk, color, newPrompt, icon, iconColor, buttonColor, ok, link }) {
  let resolver = null;
  return dispatch => {
    let consequence = new Consequence({
      dispatch   : dispatch,
      payload    : { data: { message, title, color, newPrompt, icon, iconColor, buttonColor, ok, link, hooks: { onCancel: catchAction, onOk: catchAction } } },
      eventTypes : { success: ARM_PROMPT, error: 'ERROR' }

    }) // END consequence

    consequence.then();
    dispatch({ type: SHOW_PROMPT, payload: true });

    return new Promise(resolve => {
      resolver = resolve

    });

    function catchAction(confirmation){
      if (confirmation === 'cancel' && typeof onCancel === 'function') {
        onCancel();

      } else if (confirmation === 'ok' && typeof onOk === 'function') {
        onOk();

      } // END if

      resolver(confirmation);
      dispatch({ type: SHOW_PROMPT, payload: false });

    } // END catchAction

  }; // END return

} // END promptUser

export function showNormalNotification({ className, message, color, unique, duration }) {
  let d = new Date();
  return {
    type: SHOW_COLORED_NOT,
    payload: { className,  message, color, type: 'normal', ts: unique ? d.getMinutes() : d.getSeconds(), duration }

  } // END return

} // END showNormalNotification


export function showNotificationBar({ message, color, unique, duration }) {
  let d = new Date();
  return {
    type: SHOW_FULL_WIDTH_NOT,
    payload: { message, color, type: 'bar', ts: unique ? d.getMinutes() : d.getSeconds(), duration }

  } // END return

} // END showNotificationBar

export function showTopBarNotification({ message, messageTitle, color, icon, action, actionFunction, unique, duration }) {
  let d = new Date();
  return Promise.resolve({
    type: SHOW_FULL_WIDTH_NOT,
    payload: { message, messageTitle, color, icon, action, actionFunction, type: 'caution', ts: unique ? d.getMinutes() : d.getSeconds(), duration }

  }) // END return

} //END showTopBarNotification

export function decreaseTopBarNotification() {
  return {
    type: DECREASE_SHOW_FULL_WIDTH_NOT

  } // END return

} //END decreaseTopBarNotification

export function updateSatAlertStatus(payload) {
  return {
    type: SAT_ALERT,
    payload: payload

  } // END return

} // End updateSatAlertStatus

export function showImageNotification({ message, title, img, unique, duration }) {
  let d = new Date();
  return {
    type: SHOW_IMAGE_NOT,
    payload: { message, title, img, type: 'image', ts: unique ? d.getMinutes() : d.getSeconds(), duration }

  } // END return

} // END showImageNotification


export function showBasicNotification({ message, title, unique, duration }) {
  let d = new Date();
  return {
    type: SHOW_BASIC_NOT,
    payload: { message, title, type: 'basic', ts: unique ? d.getMinutes() : d.getSeconds(), duration }

  } // END return

} // END showBasicNotification



// WEBPACK FOOTER //
// ./src/redux/actions/notificationsActions.js